import { ArrowForward, Circle, Mic, Search } from '@mui/icons-material';
import { Avatar, Box, Grid, IconButton, Typography, Skeleton, Tooltip } from '@mui/material';
import React, { useEffect, useState, useContext } from 'react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { RiHospitalLine } from 'react-icons/ri';
import SelectedDoctor from './SelectedDoctor';
import { useTheme } from '@mui/material/styles';
import HowToPayModal from './HowToPayModal';
import { get } from "../../utility/fetchWeb";
import VoiceRecorder from '../inputs/VoiceRecorder';
import { useNavigate } from 'react-router-dom';
import MapSelector from '../Layout/MapSelector';
import Select from "react-select";
import { UserContext } from '../../contexts/UserContext';
import PromoBanner from '../Layout/PromoBanner';
import Pagination from '../Layout/Pagination';

const DoctorEngagement = () => {
    const theme = useTheme();
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
    const [selectedDrug, setSelectedDrug] = useState(null);
    const [isVoiceModalOpen, setIsVoiceModalOpen] = useState(false);
    const [isListening, setIsListening] = useState(false);
    const [voiceSearchResults, setVoiceSearchResults] = useState([]);
    const [showVoiceResults, setShowVoiceResults] = useState(false);
    const [doctors, setDoctors] = useState([])
    const [showRecommended, setShowRecommended] = useState(false);
    const [recommendedDoctors, setRecommendedDoctors] = useState([]);
    const [loading, setLoading] = useState(false)
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [currentLocation, setCurrentLocation] = useState(null);
    const [allDoctors, setAllDoctors] = useState([]);
    const [targetedAds, setTargetedAds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [transcript, setTranscript] = useState('');

    const { profilePicture } = useContext(UserContext);

    const navigate = useNavigate();

    const handleLocationSelect = (location, address) => {
        console.log("Selected Location:", location);
        console.log("Selected Address:", address);
    };

    const name = sessionStorage.getItem("name").toString();
    const getEngagedDoctors = async (page = 1) => {
        setLoading(true)
        try {
            const response = await get(`/doctors/list/true?pageNumber=${page}&pageSize=10`);
            console.log('Response:', response);
            setDoctors(response?.data?.recordList);
            setAllDoctors(response?.data?.recordList)
            setTotalPages(response?.data?.metadata?.totalPages || 1);
            setCurrentPage(response?.data?.metadata?.page || page);
        } catch (error) {
            console.error("Error fetching doctors:", error);
        }
        setLoading(false)
    }

    const getSearchedHealthCareProvider = async (searchText, page = 1) => {
        setLoading(true);
        try {
            let response = await get(`/Doctors/filter-list/true?pageNumber=${page}&pageSize=10&filterOn=Doctor&filterQuery=${searchText}`);
            setDoctors(response?.data?.recordList || []);
            setTotalPages(response?.data?.metadata?.totalPages || 1);
            setCurrentPage(response?.data?.metadata?.page || page);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching doctors:', error);
            setDoctors([]);
            setLoading(false);
        }
    }

    const handlePageChange = (page) => {
        if (searchQuery.length >= 3) {
            getSearchedHealthCareProvider(searchQuery, page);
        } else {
            getEngagedDoctors(page);
        }
    };

    useEffect(() => {
        if (searchQuery.length >= 3) {
            getSearchedHealthCareProvider(searchQuery, currentPage);
        } else if (searchQuery.length === 0) {
            getEngagedDoctors();
        }
    }, [searchQuery]);

    useEffect(() => {
        getCategories()
    }, []);

    const handleTranscript = async (transcript) => {
        if (!transcript || transcript.trim() === '') {
            return;
        }

        setLoading(true);
        setTranscript(transcript);
        setIsListening(true);

        try {
            const response = await get(`/Doctors/GetRecommendedDoctors?summary=${encodeURIComponent(transcript)}`);
            console.log('Recommended doctors:', response);
            setRecommendedDoctors(response);
            setShowRecommended(true);
            setShowVoiceResults(true);
            setIsVoiceModalOpen(false);
        } catch (error) {
            console.error('Error fetching doctors:', error);
            setRecommendedDoctors([]);
            setShowRecommended(true);
        } finally {
            setIsListening(false);
            setLoading(false);
        }
    };

    // Modify the handleSearchChange function
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setTranscript(''); // Clear transcript when typing
        setShowRecommended(false);
    };

    // Add a function to clear transcript
    const clearTranscript = () => {
        setTranscript('');
        setShowRecommended(false);
        setRecommendedDoctors([]);
    };

    // Handle cart icon click
    const handleCartClick = (e, result) => {
        e.stopPropagation(); // Prevent triggering the card click
        setSelectedDrug(result);
        setIsPaymentModalOpen(true);
    };

    // Handle modal close
    const handleModalClose = () => {
        setIsPaymentModalOpen(false);
        setSelectedDrug(null);
    };

    // Get doctor email for the selected drug
    const getDoctorEmail = (doctorId) => {
        const doctor = doctors.find(d => d.id === doctorId);
        return doctor ? doctor.email : "admin@doctor.com";
    };

    // Voice search functions
    const handleMicClick = () => {
        setIsVoiceModalOpen(true);
    };

    const handleVoiceModalClose = () => {
        setIsVoiceModalOpen(false);
        setIsListening(false);
    };

    const handleVoiceResultClick = (result) => {
        const doctor = doctors?.find(d => d?.id === result.doctorId);
        setSelectedDoctor(doctor);
    };

    // if (selectedDoctor) {
    //     return (
    //         <SelectedDoctor
    //             doctor={selectedDoctor}
    //             handleBackClick={handleBackClick}
    //         />
    //     );
    // }

    const getCategories = async () => {
        try {
            const response = await get("/Categories/SpecialistCategories");
            const newResponse = [
                { id: 0, name: "All", description: "All Categories" },
                ...response.data,
            ];
            setCategories(newResponse.map((cat) => ({ value: cat.name, label: cat.name })));
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const getTargetedAds = async () => {
        try {
            const userId = sessionStorage.getItem('userId');
            const pageName = 'Doctor Search';
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/connecthealthadmin/api/ad/find-ad?Id=${userId}&page=${pageName}`);

            if (response.ok) {
                const data = await response.json();
                const transformedAds = data.map(ad => ({
                    id: ad.id,
                    imageUrl: ad.bannerImageUrl,
                    title: ad.title,
                    subtitle: ad.description,
                    redirectUrl: ad.redirectUrl,
                    status: 1,
                    isTargeted: true
                }));
                setTargetedAds(transformedAds);
            }
        } catch (error) {
            console.error('Error fetching targeted ads:', error);
            setTargetedAds([]);
        }
    };

    useEffect(() => {
        getCategories();
        getTargetedAds();
    }, []);

    return (
        <div className="pharmacy-page w-100">
            <Grid item display="flex" alignItems="center">
                <Avatar
                    src={profilePicture || undefined}
                    sx={{ width: 64, height: 64, mr: 3, backgroundColor: 'primary.main' }}
                >
                    {!profilePicture && <AccountCircleIcon fontSize="large" />}
                </Avatar>
                <Box>
                    <Typography variant="subtitle2" color="text.secondary">Good Day</Typography>
                    <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 0.5 }}>{name}</Typography>
                </Box>
            </Grid>

            {/* Search Bar Section */}
            <div className="search-section">
                <div className="search-bar">
                    <Search className='search-icon' />
                    <input
                        type="text"
                        placeholder="Search for doctors, specialists..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                    />
                    {(searchQuery || transcript) && (
                        <button
                            className="clear-button"
                            onClick={() => {
                                setSearchQuery('');
                                clearTranscript();
                            }}
                        >
                            ×
                        </button>
                    )}
                </div>
                <Tooltip title="Tap to describe your symptoms and get doctor recommendations">
                    <div className="filter-btn" onClick={handleMicClick}>
                        <Mic color='white' />
                    </div>
                </Tooltip>
            </div>

            {/* Display transcript if exists */}
            {transcript && (
                <Box sx={{ mt: 2, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="body2" color="text.secondary">
                        Voice search: "{transcript}"
                    </Typography>
                </Box>
            )}

            {/* Filter Bar */}
            <Box display="flex" flexDirection={"column"} justifyContent="flex-end" gap={2} mt={2} mb={3}>
                {/* Category Dropdown */}
                <Box sx={{ minWidth: 200 }}>
                    <Select
                        options={categories}
                        value={selectedCategory}
                        onChange={(selectedOption) => {
                            setSelectedCategory(selectedOption);

                            if (selectedOption?.value === "All" || !selectedOption) {
                                setDoctors(allDoctors);
                            } else {
                                const filteredDoctors = allDoctors?.filter((item) => {
                                    const specialist =
                                        item?.userRoles[0]?.roleSpecialist?.specialistName?.toLowerCase() ||
                                        "";
                                    return specialist.includes(selectedOption.value.toLowerCase());
                                });
                                setDoctors(filteredDoctors);
                            }
                        }}
                        placeholder="Select Category"
                        isClearable
                        styles={{
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 1300, // Ensure dropdown appears above other elements
                            }),
                        }}
                    />
                </Box>

                {/* Map Selector */}
                <Box sx={{ flex: 1 }}>
                    <MapSelector
                        onLocationSelect={handleLocationSelect}
                        currentLocation={currentLocation}
                    />
                </Box>

                {/* Add PromoBanner after search section */}
                {targetedAds.length > 0 && (
                    <Box sx={{ mb: 3 }}>
                        <PromoBanner ads={targetedAds} />
                    </Box>
                )}
            </Box>

            <>
                {/* ===================== RESULTS SECTION ===================== */}

                {loading ? (
                    // Skeletons...
                    <div className="pharmacy-list">
                        {[...Array(6)].map((_, index) => (
                            <div key={index} className="pharmacy-card">
                                <Skeleton variant="circular" width={56} height={56} />
                                <div className="pharmacy-info">
                                    <Skeleton variant="text" width="60%" height={20} />
                                    <Skeleton variant="text" width="80%" height={24} />
                                    <Skeleton variant="text" width="90%" height={16} />
                                </div>
                                <div className="doctor-info">
                                    <Skeleton variant="text" width="70%" height={20} />
                                    <Skeleton variant="text" width="50%" height={16} />
                                </div>
                                <Skeleton variant="circular" width={24} height={24} />
                            </div>
                        ))}
                    </div>
                ) : (
                    <>
                        {/* Voice Recorder Modal */}
                        {isVoiceModalOpen && (
                            <VoiceRecorder
                                onTranscript={async (transcript) => {
                                    if (transcript) {
                                        await handleTranscript(transcript);
                                    }
                                    setIsVoiceModalOpen(false);
                                    setIsListening(false);
                                }}
                                provider={"Doctor"}
                            />
                        )}

                        {/* ===================== 1️⃣ RECOMMENDED DOCTORS (VOICE SEARCH) ===================== */}
                        {showRecommended ? (
                            <div className="search-results">
                                <div className="voice-result-header">
                                    <p>
                                        From your voice description, here are the doctors we recommend:
                                    </p>
                                </div>

                                {recommendedDoctors?.length > 0 ? (
                                    <div className="search-results-list">
                                        {recommendedDoctors.map((doctor) => (
                                            <div
                                                key={doctor.id}
                                                className="doctor-search-result-card"
                                                onClick={() =>
                                                    navigate(`/profile?cat=doctor&id=${doctor?.id}`)
                                                }
                                            >
                                                <div className="doctor-info-header">
                                                    <div className="doctor-avatar-section">
                                                        <Avatar
                                                            src={doctor.profilePicture || undefined}
                                                            sx={{ width: 48, height: 48, mr: 2 }}
                                                        >
                                                            {!doctor.profilePicture && <AccountCircleIcon />}
                                                        </Avatar>
                                                        <div className="doctor-name-specialty">
                                                            <h4 className="doctor-name-search">
                                                                {`${doctor.title} ${doctor.firstName} ${doctor.lastName}`}
                                                            </h4>
                                                            <div className="doctor-specialty-pill">
                                                                {doctor.userRoles?.[0]?.roleSpecialist?.specialistName ||
                                                                    "Private Practitioner"}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="consultation-fee">
                                                        <span className="fee-label">Rating</span>
                                                        <span className="fee-amount">
                                                            ★ {doctor.rating || "N/A"}
                                                        </span>
                                                        {doctor.rating > 0 && (
                                                            <div className="verified-status">✓ Verified</div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="doctor-details">
                                                    <div className="doctor-info-search">
                                                        <h5 className="hospital-name-search">
                                                            {doctor.healthCareProvider?.name ||
                                                                "Healthcare Provider"}
                                                        </h5>
                                                        <p className="hospital-type-search">
                                                            {doctor.department || "Unknown Department"}
                                                        </p>
                                                        <p className="doctor-availability">
                                                            Experience: {doctor.workGrade || "Not specified"}
                                                        </p>
                                                        <div className="doctor-rating-section">
                                                            <span className="rating">★ {doctor.rating}</span>
                                                            <span className="review-count">
                                                                ({doctor.reviews} reviews)
                                                            </span>
                                                            <span className="experience-info">
                                                                • Resumed: {doctor.resumptionDate || "N/A"}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="hospital-icon-search">
                                                        {doctor.healthCareProvider?.logoPath ? (
                                                            <img
                                                                src={
                                                                    doctor.healthCareProvider.logoPath.startsWith("http")
                                                                        ? doctor.healthCareProvider.logoPath
                                                                        : `${process.env.REACT_APP_MEDIA_URL}${doctor.healthCareProvider.logoPath}`
                                                                }
                                                                alt="Healthcare Provider"
                                                                style={{
                                                                    width: "24px",
                                                                    height: "24px",
                                                                    borderRadius: "4px",
                                                                }}
                                                                onError={(e) => {
                                                                    e.target.style.display = "none";
                                                                    e.target.nextSibling.style.display = "block";
                                                                }}
                                                            />
                                                        ) : null}
                                                        <RiHospitalLine
                                                            style={{
                                                                display: doctor.healthCareProvider?.logoPath
                                                                    ? "none"
                                                                    : "block",
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="action-buttons">
                                                        <IconButton>
                                                            <ArrowForward className="arrow-icon" />
                                                        </IconButton>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <>
                                        <Box sx={{ textAlign: "center", mt: 4 }}>
                                            <Typography variant="h6" color="text.secondary">
                                                We couldn’t find any doctor matching your voice description.
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                You can browse through the available doctors below, search by name, or filter by category.
                                            </Typography>
                                        </Box>

                                        {/* Browse All Doctors Section - Only shown on voice search failure */}
                                        <Box sx={{ mt: 4 }}>
                                            <Typography
                                                variant="h6"
                                                sx={{ mb: 2, fontWeight: "bold", color: "text.primary" }}
                                            >
                                                Browse All Doctors
                                            </Typography>
                                            <div className="pharmacy-list">
                                                {doctors?.map((doctor) => (
                                                    <div
                                                        key={doctor.id}
                                                        className="pharmacy-card"
                                                        onClick={() => navigate(`/profile?cat=doctor&id=${doctor?.id}`)}
                                                    >
                                                        <div className="pharmacy-icon">
                                                            {doctor.profilePicture ? (
                                                                <img
                                                                    src={
                                                                        doctor.profilePicture.startsWith("http")
                                                                            ? doctor.profilePicture
                                                                            : `${process.env.REACT_APP_MEDIA_URL}${doctor.profilePicture}`
                                                                    }
                                                                    alt="Doctor"
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        objectFit: "cover",
                                                                        borderRadius: "12px",
                                                                    }}
                                                                />
                                                            ) : null}
                                                            <RiHospitalLine
                                                                style={{
                                                                    display: doctor.profilePicture ? "none" : "block",
                                                                    fontSize: "24px",
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="pharmacy-info">
                                                            <h5 className="doctor-name">
                                                                {doctor.title} {doctor.firstName} {doctor.lastName}
                                                            </h5>
                                                            <p className="doctor-role">
                                                                {doctor.userRoles?.[0]?.roleSpecialist?.specialistName ||
                                                                    "N/A"}
                                                            </p>
                                                            <div className="doctor-rating">
                                                                <span className="rating">★ {doctor.rating || "N/A"}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            {totalPages > 1 && (
                                                <Pagination
                                                    currentPage={currentPage}
                                                    totalPages={totalPages}
                                                    onPageChange={handlePageChange}
                                                />
                                            )}
                                        </Box>
                                    </>
                                )}
                            </div>
                        ) : (
                            /* ===================== 2️⃣ NORMAL DOCTOR SEARCH ===================== */
                            <div>
                                {/* Header for regular results */}
                                {searchQuery ? (
                                    <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold", color: "text.primary" }}>
                                        Search results for "{searchQuery}"
                                    </Typography>
                                ) : (
                                    <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold", color: "text.primary" }}>
                                        All Doctors
                                    </Typography>
                                )}

                                {doctors?.length > 0 ? (
                                    <div className="pharmacy-list">
                                        {doctors.map((doctor) => (
                                            <div
                                                key={doctor.id}
                                                className="pharmacy-card"
                                                onClick={() => navigate(`/profile?cat=doctor&id=${doctor?.id}`)}
                                            >
                                                {/* Existing doctor card layout */}
                                                <div className="pharmacy-icon">
                                                    {doctor.profilePicture ? (
                                                        <img
                                                            src={
                                                                doctor.profilePicture.startsWith("http")
                                                                    ? doctor.profilePicture
                                                                    : `${process.env.REACT_APP_MEDIA_URL}${doctor.profilePicture}`
                                                            }
                                                            alt="Doctor"
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                objectFit: "cover",
                                                                borderRadius: "12px",
                                                            }}
                                                        />
                                                    ) : null}
                                                    <RiHospitalLine
                                                        style={{
                                                            display: doctor.profilePicture ? "none" : "block",
                                                            fontSize: "24px",
                                                        }}
                                                    />
                                                </div>
                                                <div className="pharmacy-info">
                                                    <h5 className="doctor-name">
                                                        {doctor.title} {doctor.firstName} {doctor.lastName}
                                                    </h5>
                                                    <p className="doctor-role">
                                                        {doctor.userRoles?.[0]?.roleSpecialist?.specialistName ||
                                                            "N/A"}
                                                    </p>
                                                    <div className="doctor-rating">
                                                        <span className="rating">★ {doctor.rating || "N/A"}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        {totalPages > 1 && (
                                            <Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                onPageChange={handlePageChange}
                                            />
                                        )}
                                    </div>
                                ) : (
                                    <Box sx={{ mt: 4, textAlign: "center" }}>
                                        <Typography variant="h6" color="text.secondary">
                                            No doctors found matching your search.
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Try a different name or clear the search bar.
                                        </Typography>
                                    </Box>
                                )}
                            </div>
                        )}
                    </>
                )}
            </>

            {/* Payment Modal */}
            <HowToPayModal
                open={isPaymentModalOpen}
                onClose={handleModalClose}
                amount={selectedDrug ? selectedDrug.priceNumeric : 0}
                doctorName="Dr. Ember Wynn"
                email={selectedDrug ? getDoctorEmail(selectedDrug.doctorId) : "admin@doctor.com"}
            />

            <style jsx>{`
                /* ...existing styles... */
                
                .doctor-avatar-section {
                    display: flex;
                    align-items: center;
                }
                
                .doctor-name-specialty {
                    flex: 1;
                }
                
                /* ...existing styles... */

                .clear-button {
                    background: none;
                    border: none;
                    color: #666;
                    cursor: pointer;
                    font-size: 18px;
                    padding: 0 8px;
                    position: absolute;
                    right: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                }

                .clear-button:hover {
                    color: #333;
                }

                .search-bar {
                    position: relative;
                    flex: 1;
                }
            `}</style>
        </div>
    );
};

export default DoctorEngagement;